import { t } from '@hefe/i18n';
import { ResetPasswordSlice } from '@hefe/store';
import { Button, Col, message, Result, Row } from 'antd';
import get from 'lodash/get';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import bannerWhite from '../../../../assets/images/logo/banner_white.png';
import CustomForm, {
  FormField,
} from '../../../containers/core/components/form/custom-form';
import { useAppDispatch } from '../../../store/store';
import styles from './reset-password.page.module.scss';

/* eslint-disable-next-line */
export interface ResetPasswordProps {}

export function ResetPasswordPage(props: ResetPasswordProps) {
  const [successful, setSuccessful] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const dispatch = useAppDispatch();
  const params = useParams();
  const navigate = useNavigate();

  const handleSubmit = async (values: any) => {
    const submitValues = {
      ...values,
      token: params['token'],
    };

    setLoading(true);
    dispatch(ResetPasswordSlice.resetPassword(submitValues))
      .unwrap()
      .then((res: any) => {
        if (res.initial) {
          navigate('/welcome', {
            state: { club: res.club },
          });
        } else {
          setSuccessful(true);
        }
      })
      .catch((error: any) => {
        const errorMessage = get(error.data, 'message');
        if (errorMessage) {
          message.error(t('errors.' + errorMessage), 10);
        } else {
          message.error(t('errors.reset_password'), 10);
        }
      })
      .finally(() => setLoading(false));
  };

  const fields: FormField[] = [
    {
      name: 'email',
      type: 'email',
      label: '',
      placeholder: t('email'),
      rules: [
        {
          required: true,
          type: 'email',
          message: t('form_errors.email'),
        },
      ],
    },
    {
      name: 'password',
      type: 'password',
      label: '',
      placeholder: t('password'),
      rules: [
        {
          required: true,
          type: 'string',
          message: t('form_errors.password'),
        },
        {
          min: 8,
          message: t('form_errors.password_length'),
        },
      ],
    },
    {
      name: 'password_confirmation',
      type: 'password',
      label: '',
      placeholder: t('password_confirmation'),
      rules: [
        {
          required: true,
          type: 'string',
          message: t('form_errors.password'),
        },
        ({ getFieldValue }) => ({
          validator(_, value) {
            if (!value || getFieldValue('password') === value) {
              return Promise.resolve();
            }
            return Promise.reject(new Error(t('form_errors.password_confirm')));
          },
        }),
      ],
    },
  ];

  const renderSuccess = () => {
    return (
      <Result
        status="success"
        title="Swish"
        subTitle={t('success.reset_password')}
        extra={[
          <Button type="primary" onClick={() => navigate('/login')}>
            {t('back_to_login')}
          </Button>,
        ]}
      />
    );
  };

  const renderForm = () => {
    return (
      <div>
        <h3>{t('reset_password')}</h3>
        <CustomForm
          fields={fields}
          onSubmit={(values) => handleSubmit(values)}
          loading={isLoading}
          submitButtonText="reset_password"
        />
      </div>
    );
  };

  return (
    <div className={styles['container']}>
      <Row align="middle">
        <Col md={12} xs={24}>
          <div className={styles['content']}>
            <img alt="Backcourt Logo" src={bannerWhite} width="60%" />
            <h1 className={styles['info-header']}>
              {t('information_texts.reset_password')}
            </h1>
          </div>
        </Col>
        <Col md={12} xs={24}>
          <div className={styles['content']}>
            <div className={styles['login-panel']}>
              {successful ? renderSuccess() : renderForm()}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ResetPasswordPage;
